import { render, staticRenderFns } from "./record-ope.vue?vue&type=template&id=2f0683db&scoped=true&"
import script from "./record-ope.vue?vue&type=script&lang=js&"
export * from "./record-ope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0683db",
  null
  
)

export default component.exports